const mutations = {
  SET_REVS(state, revs) {
    state.revs = revs
  },

  updateLocationFilters(state, filters) {
    state.locationFilters = {
      sites: filters.sites || null,
    }
    if (filters.tags) state.locationFilters.tags = filters.tags
  },

  updateValidation(state, validations) {
    state.rev.validation = validations
  },
}

export default mutations
